<!-- <div class="vh-100 d-flex justify-content-center" id="dark">
  <div class="col-md-2">
    <img style="width: 45%;" src="./assets/identity/logo.png">
  </div>
  <div class="form-access my-auto">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username">Username</label>
        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Username is required</div>
        </div>
      </div>

      <div class="form-group">
        <label>Password</label>
        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">Password is required</div>
        </div>
      </div>
      <div class="checkbox">
        <label>
          <input type="checkbox"> Remember Me
        </label>
        <label class="pull-right">
          <a href="#">Forgotten Password?</a>
        </label>

      </div>
      <button [disabled]="loading" class="btn btn-primary">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Login
      </button>
      <div class="register-link m-t-15 text-center">
        <p>Don't have account ? <a href="#"> Sign Up Here</a></p>
      </div>
    </form>
    <h2>Don't have an account? <a href="signup-dark.html">Sign up here</a></h2>
  </div>
</div> -->

<!-- This snippet uses Font Awesome 5 Free as a dependency. You can download it at fontawesome.io! -->

<body >
  <div class="container vh-100" *ngIf="isEGID">
    <div class="row vh-100">
      <div class="col-lg-10 col-xl-9 m-auto">
        <div class="card flex-row border-0 shadow rounded-10 overflow-hidden">
          <div class="card-img-left d-none d-md-flex" style="overflow:hidden">
            <img src="./assets/img/login-background.jpg">
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div style="text-align: end; width: 100%;" class="switch-lang">
                  <button class="btn p-0" (click)="switchLang()">
                    <img src="https://hatscripts.github.io/circle-flags/flags/us.svg" width="28" *ngIf="translate.currentLang =='ar'">
                    <img src="https://hatscripts.github.io/circle-flags/flags/eg.svg" width="28" *ngIf="translate.currentLang =='en'">
                  </button>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <img src="./assets/identity/logo.png" style="width: 35%;">
              <!-- <h3 class="card-title text-start mb-4 ">Login</h3> -->
            </div>
            <br>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="form-group" style="text-align: start;">
                <label for="username">{{'username' | translate}}</label>
                <input type="text" formControlName="username" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                  <div *ngIf="f.username.errors.required">{{'username-required'|translate}}</div>
                </div>
              </div>

              <div class="form-group" style="text-align: start;">
                <label>{{'password'|translate}}</label>
                <input type="password" formControlName="password" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required">{{'password-required'|translate}}</div>
                </div>
              </div>
              <div class="checkbox d-flex justify-content-between mb-2">
                <label >
                  <input class="mx-1" [(ngModel)]="remeberMe" [ngModelOptions]="{standalone: true}" type="checkbox">
                  {{"remember-me"|translate}}
                </label>
                <label>
                  <a [routerLink]="['/VerifyEmail']">{{"forgot-password"|translate}}</a>
                </label>
              </div>
              <br>

              <div class="d-flex justify-content-between">
                <div>
                  <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    {{"login"|translate}}
                  </button>
                </div>
                <div class="d-flex align-items-center">
                  <h3 style="margin: 0px 3px !important;">{{supportNumber}}</h3>
                  <img class="contact-icon" src="assets/img/telephone-call.png" />
                </div>
              </div>

              <div class="row justify-content-between align-items-center mx-1">
                <div class="d-flex justify-content-sm-start mt-3">
                  <a href="./assets/download/TruckScaleSetup.msi" class="font-small"><i class="fas fa-download"></i></a>
                  <a (click)="loginWithToken()" class="text-primary font-small">Token</a>
                </div>

                <div class="d-flex flex-column align-items-center mt-3" style="line-height: 1.4;">
                  <small class="color-sec">{{"follow-us"|translate}}</small>
                  <div class="social-icons" class="flex-row">
                    <a target="_black" [href]="companySettings?.OtherSettings?.InstagramLink">
                      <i class="fa-brands mx-1 fa-instagram ">
                      </i>
                    </a>
                    <a target="_black" [href]="companySettings?.OtherSettings?.FacebookLink" >
                      <i class="fa-brands mx-1 fa-facebook "></i>
                    </a>
                    <a target="_black" [href]="companySettings?.OtherSettings?.LinkedInLink">
                      <i class="fa-brands mx-1 fa-linkedin "></i>
                    </a>
                  </div>
                </div>
              </div>
            </form>
            <br>
          </div>
        </div>
        <div class="version">
          {{currentVersion}}
        </div>
      </div>
    </div>
  </div>
  <app-new-login *ngIf="!isEGID"></app-new-login>
</body>
